module.exports = __webpack_public_path__ + "media/images/arrow-1f5d456f51bea56a2bbfbc510fda513a.svg";